import { EcrDefinitionsInfo } from "@/model/data/ecr/EcrDefinitionsInfo";
import { FitnessStatisticsState } from "./state";

export const SET_AVAILABLE_ECR_CODES = "SET_AVAILABLE_ECR_CODES";
export const SET_AVAILABLE_SENSOR_MODELS = "SET_AVAILABLE_SENSOR_MODELS";
export const SET_AVAILABLE_SENSOR_FIRMWARES = "SET_AVAILABLE_SENSOR_FIRMWARES";
export const SET_ECR_FILE_VERSION = "SET_ECR_FILE_VERSION";
export const SET_ECR_FILE_LAST_UPDATE = "SET_ECR_FILE_LAST_UPDATE";

export default {

    [SET_AVAILABLE_ECR_CODES](state: FitnessStatisticsState, availableEcrCodes: EcrDefinitionsInfo[]) {
        state.availableEcrCodes = availableEcrCodes;
    },

    [SET_AVAILABLE_SENSOR_MODELS](state: FitnessStatisticsState, availableSensorModels: string[]) {
        state.availableSensorModels = availableSensorModels;
    },

    [SET_AVAILABLE_SENSOR_FIRMWARES](state: FitnessStatisticsState, availableSensorFirmwares: string[]) {
        state.availableSensorFirmwares = availableSensorFirmwares;
    },

    [SET_ECR_FILE_VERSION](state: FitnessStatisticsState, ecrFileVersion: string) {
        state.ecrFileVersion = ecrFileVersion;
    },

    [SET_ECR_FILE_LAST_UPDATE](state: FitnessStatisticsState, ecrFileLastUpdate: Date) {
        state.ecrFileLastUpdate = ecrFileLastUpdate;
    },

}